import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { INotification, INotifications } from 'types/notification'
import { IPaginationQueryInfo } from 'types/pagination'

export const notificationApi = createApi({
  reducerPath: 'notifications',
  baseQuery,
  tagTypes: ['Notifications'],
  endpoints: (builder) => ({
    notifications: builder.query<INotifications, IPaginationQueryInfo>({
      query: ({ page, size, orgName, from, until }) => {
        const params = new URLSearchParams()

        if (size) {
          params.set('size', String(size))
        }
        if (page) {
          params.set('page', String(page))
        }

        if (orgName && orgName.length > 0) {
          params.set('orgName', orgName)
        }
        if (from && from.length > 0) {
          params.set('from', from)
        }
        if (until && until.length > 0) {
          params.set('until', until)
        }

        return {
          url: '/sys-notif',
          method: 'get',
          params,
        }
      },
      providesTags: ['Notifications'],
    }),

    notification: builder.query<INotification, IdParams>({
      query: ({ id }) => `/sys-notif/${id}`,
    }),

    createNotification: builder.mutation<void, Partial<INotification>>({
      query: (body) => ({
        url: `/sys-notif`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['Notifications'],
    }),

    deleteNotification: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/sys-notif/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Notifications'],
    }),
  }),
})

export const {
  useNotificationsQuery,
  useNotificationQuery,
  useDeleteNotificationMutation,
  useCreateNotificationMutation,
} = notificationApi
